import React from 'react';
import SingleFeature from '../../components/Feature';

const Feature = () => {
  return (
    <div className="it-feature-area fix pt-120 pb-90">
      <div className="container">
        <div className="row gx-35">
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleFeature
              icon="flaticon-brain"
              title="العلاج والدعم المتخصص"
              description="من المهم أن يكون لديك خدمة عملاء، ولكن ستتبعها خدمة عملاء
                    ولكن في مثل هذا الوقت سقطوا بمشقة وألم شديدين
                    بعض لذلك"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleFeature
              icon="flaticon-idea"
              title="التشخيص والتحقيق البشري"
              description="من المهم أن يكون لديك خدمة عملاء، ولكن ستتبعها خدمة عملاء
                    ولكن في مثل هذا الوقت سقطوا بمشقة وألم شديدين
                    بعض لذلك"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleFeature
              icon="flaticon-artificial-intelligence"
              title="العلاج الطبي والجراحي"
              description="من المهم أن يكون لديك خدمة عملاء، ولكن ستتبعها خدمة عملاء
                    ولكن في مثل هذا الوقت سقطوا بمشقة وألم شديدين
                    بعض لذلك"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
